import { useTranslation } from "@next-platform/client-common-core";
import { useMemo } from "react";

export function useChatJsonLdTokens(characterName: string | undefined) {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      webPageName: characterName ?? "",
      webPageDescription: t("meta:jsonLd.chat.description", { characterName: characterName ?? "" }),
    }),
    [characterName, t],
  );
}
